import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { LotsManagementEditCrumbs } from 'front-office/constants/lots-management-crumbs';
import { Card, CardActions, CardContent, Typography, useEventCallback } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FormEdit from 'front-office/components/lots-management/edit';
import { Form, Formik } from 'formik';
import { validationSchemaEdit } from 'front-office/constants/lots-management-schema';
import { LotsManagementEditVM } from 'front-office/view-models/lots-management/edit';
import { PmiButton } from 'shell/components/shared/button';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __PERSON_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { toast } from 'react-toastify';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseLotsManagement } from 'shell/models/lots-management';
import { transformerLotsManagementDataEdit } from 'front-office/utils/transformer-lots-management';

const LotsManagementEdit = (): ReactElement => {
  const navigate = useNavigate();

  const [queryParams] = useSearchParams();

  const dataAssegnazione = queryParams.get('dataAssegnazione') || '';
  const oraAssegnazione = queryParams.get('oraAssegnazione') || '';
  const ente = queryParams.get('ente') || '';
  const operatore = queryParams.get('operatore') || '';
  const servizio = queryParams.get('servizio') || '';

  const [lots] = useHttpFetch<HttpResponse<ResponseLotsManagement>, LotsManagementEditVM>(
    `${__PERSON_API_URL__}/persona/lotto-carte/lotto-cid`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {
          dataAssegnazione,
          oraAssegnazione,
          ente,
          operatore,
          servizio,
        },
      },
      transformer: transformerLotsManagementDataEdit,
    }
  );

  const onCancel = useEventCallback(() => {
    navigate('/sportello/gestione-lotti');
  });

  const update = useHttpClient(`${__PERSON_API_URL__}/persona`, {
    options: {
      errorCatching: true,
      method: 'PUT',
      loading: true,
      data: {},
    },
  });

  const onSubmit = useEventCallback((values: LotsManagementEditVM) => {
    const data = {
      numeroInizioLotto: values.fromNumber || undefined,
      numeroFineLotto: values.toNumber || undefined,
      numeroInizioLottoOld: values.oldFromNumber || undefined,
      numeroFineLottoOld: values.oldToNumber || undefined,
      numeroRilasciate: values.released === 0 || values.released ? values.released : undefined,
    };

    (
      update({
        data,
        url: values.isRectificationCards
          ? '/lotto-carte/rettifica-totale-carte-rilasciate'
          : '/lotto-carte/rettifica-inizio-fine-lotto',
      }) as ResponsePromise<void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/gestione-lotti');
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={LotsManagementEditCrumbs} />
      {lots.data ? (
        <Card raised className="pmi-my-3">
          <Formik
            validationSchema={validationSchemaEdit}
            initialValues={lots.data as LotsManagementEditVM}
            onSubmit={onSubmit}
          >
            <Form>
              <CardContent style={{ padding: '24px' }}>
                <Typography gutterBottom variant="h5" component="h2">
                  Modifica lotto
                </Typography>
                <div style={{ padding: '24px 0 0 0' }}>
                  <FormEdit />
                </div>
              </CardContent>
              <CardActions style={{ padding: '24px 24px 16px 24px' }}>
                <PmiButton variant="contained" color="primary" type="submit">
                  Conferma
                </PmiButton>
                <PmiButton
                  variant="outlined"
                  color="cdmBrand"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  Esci
                </PmiButton>
              </CardActions>
            </Form>
          </Formik>
        </Card>
      ) : undefined}
    </Fragment>
  );
};

LotsManagementEdit.displayName = 'Lots Management Edit Page component';

export default LotsManagementEdit;
